export default __webpack_public_path__ + "static/armedDevice-35aa9df7965cfb69fb423091cc685db1.png";